import React from 'react';

const ImgWebp = ({src, srcWebp, alt, type = 'image/webp', ...rest}) => (
  <picture>
    <source srcSet={srcWebp} type={type} />
    <img src={src} {...rest} alt={alt}/>
  </picture>
);

export default ImgWebp;